import { render, staticRenderFns } from "./noaccess.vue?vue&type=template&id=e28e238a&scoped=true&"
import script from "./noaccess.vue?vue&type=script&lang=js&"
export * from "./noaccess.vue?vue&type=script&lang=js&"
import style0 from "./noaccess.vue?vue&type=style&index=0&id=e28e238a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28e238a",
  null
  
)

export default component.exports